import { CenterWrapper } from "./components/CenterWrapper"
import { SectionHeader } from "./components/SectionHeader"
import { styled, theme } from "../../../../styles/stitches.config"
import { Spacer } from "../../../../components/spacer/Spacer"
import { Flex } from "../../../../components/flex/Flex"
import { Span } from "../../../../components/span/Span"
import { Company } from "../../../../images/xd/icons"
import Household from "../acquisitionForm/icons/Household"
import { ProductCard } from "../acquisitionForm/sections/deliveryPointSection/ProductCard"
import { useNavigate } from "react-router"
import { ACQUISITION_FORM_LINKS } from "./links"
import { useAcquisitionProgress } from "./AcquisitionProgressContext"

const ColoredHeaderSpan = styled(Span, {
  color: theme.colors.secondary,
  marginLeft: theme.space.s1,
})
const ColoredDescSpan = styled(Span, {
  color: theme.colors.primary,
  marginLeft: theme.space.s1,
  fontWeight: theme.fontWeights.bold,
})

export function CustomerTypePage() {
  const progress = useAcquisitionProgress()
  const navigate = useNavigate()

  const handleSelect = (customerType: "household" | "business") => {
    navigate(`..${ACQUISITION_FORM_LINKS.CONTRACT_TYPE(customerType)}`)
  }

  return (
    <CenterWrapper css={{ maxWidth: "624px" }}>
      <SectionHeader stepsNum={progress.currentStep} maxSteps={progress.totalSteps}>
        Domácnost, nebo firma
      </SectionHeader>
      <Spacer size={theme.space.s8} />
      <Flex justify={"center"} wrap={"wrap"} css={{ gap: theme.space.s6 }}>
        <ProductCard
          icon={Household}
          header={
            <>
              <Span>Jsem</Span>
              <ColoredHeaderSpan>domácnost</ColoredHeaderSpan>
            </>
          }
          description={
            <>
              <Span>Vlastním fotovoltaiku a chci využívat spotové ceny elektřiny</Span>
              <ColoredDescSpan>Delta Green.</ColoredDescSpan>
            </>
          }
          onChange={() => handleSelect("household")}
        />
        <ProductCard
          icon={Company}
          header={
            <>
              <Span>Jsem</Span>
              <ColoredHeaderSpan>firma</ColoredHeaderSpan>
            </>
          }
          description={
            <>
              <Span>Zastupuji firmu a chci přejít na spotové ceny elektřiny k</Span>
              <ColoredDescSpan>Delta Green.</ColoredDescSpan>
            </>
          }
          onChange={() => handleSelect("business")}
        />
      </Flex>
      <Spacer size={theme.space.s12} />
    </CenterWrapper>
  )
}
